import DataSource from "devextreme/data/data_source";
import { loadData } from "../../utils/chunk_load";
/**
 * @returns {import("../datagrid").Plugin}
 */
export function batchLoadingDataSourcePlugin(url) {
  return {
    id: "batchLoadingDataSource",
    options: {
      paging: {
        pageSize: 100,
        enabled: true,
      },
      pager: {
        showPageSizeSelector: true,
        allowedPageSizes: [100, 200, 500],
        showInfo: true,
        showNavigationButtons: true,
      },
      scrolling: {
        mode: "standard",
      },
      dataSource: new DataSource({
        load() {
          return loadData(url);
        },
      }),
    },
  };
}
